const ACCESS_KEY = 'access';
const EXPIRES_AT_KEY = 'expires_at';

export function getAccess() {
  return localStorage.getItem(ACCESS_KEY);
}

export function getExpiresAt() {
  return localStorage.getItem(EXPIRES_AT_KEY);
}

/**
 * @param {string} token
 * @param {string|null|undefined} [expiresAt] — 登入 API `expires_at`；缺省則清掉舊值
 */
export function setAccess(token, expiresAt) {
  if (token) {
    localStorage.setItem(ACCESS_KEY, token);
  }

  if (expiresAt == null || expiresAt === '') {
    localStorage.removeItem(EXPIRES_AT_KEY);
    return;
  }

  localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt));
}

export function clearAccess() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}
